// src/components/effects/ConfettiEffect.jsx
import React from 'react';

export default function ConfettiEffect() {
  // Generamos 15 piezas de confeti con colores y posiciones aleatorias
  const pieces = Array.from({ length: 15 });
  const colors = ['bg-yellow-400', 'bg-blue-400', 'bg-pink-400', 'bg-green-400', 'bg-purple-400'];

  return (
    <div className="fixed inset-0 pointer-events-none z-[100] overflow-hidden">
      {pieces.map((_, i) => (
        <div
          key={i}
          className={`confetti ${colors[i % colors.length]}`}
          style={{
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 2}s`,
            animationDuration: `${2 + Math.random() * 2}s`
          }}
        />
      ))}
    </div>
  );
}